import { User } from "../../../../types/users";
import { getUserState } from "../../../../store";

export function waitForUserData(resolve: (value: User) => void) {
  const intervalId = setInterval(() => {
    if (getUserState().dataStatus == "completed") {
      clearInterval(intervalId);
      resolve(getUserState().data);
    }
  }, 100);
}
